export default __webpack_public_path__ + "static/media/truck.a9b5d43d.jpg";